import { supabase } from 'common/src/supabase';

export const addCommentToTask = async (
  taskId: string,
  userId: string,
  comment: string
) => {
  const { data, error } = await supabase
    .from('task_comments')
    .insert({ task_id: taskId, user_id: userId, comment })
    .select();

  if (error) throw error;
  return data;
};

export const fetchCommentsForTask = async (taskId: string) => {
  const { data, error } = await supabase
    .from('task_comments')
    .select(`
      *,
      User:User(first_name, last_name)
    `)
    .eq('task_id', taskId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data;
};

export const editComment = async (commentId: string, newComment: string) => {
  const { data, error } = await supabase
    .from('task_comments')
    .update({ comment: newComment })
    .eq('id', commentId)
    .select();

  if (error) throw error;
  return data;
};

export const deleteComment = async (commentId: string) => {
  const { data, error } = await supabase
    .from('task_comments')
    .delete()
    .eq('id', commentId);

  if (error) throw error;
  return data;
};
